// Sellers always see price; visibility controls the viewer's broadcast overlay.
export function showExposurePrice(mode?: string, seller = false): boolean {
  return seller || mode === undefined || mode === 'visible';
}

type ExposureProduct = { product_status?: string; exposure_active?: boolean | null; exposure_price_mode?: string };

export function getProductSaleStatus(status?: string): string | undefined {
  return status === '판매노출' ? '판매' : status === '품절노출' ? '품절' : status;
}

// Null supports older records; an explicit false always switches the popup off.
export function hasProductExposure(product?: ExposureProduct | string | null): boolean {
  if (product && typeof product !== 'string' && product.exposure_active != null) return product.exposure_active;
  const status = typeof product === 'string' ? product : product?.product_status;
  return status === '판매노출' || status === '품절노출';
}

export function canPurchaseProduct(product?: ExposureProduct | null): boolean {
  const status = getProductSaleStatus(product?.product_status);
  const exposed = hasProductExposure(product);
  return status !== '품절' && (status === '판매' || exposed)
    && (!exposed || showExposurePrice(product?.exposure_price_mode));
}
